export default {
  de: {
    inspectionRequiredFacilities: "Prüfpflichtige Anlagen",
    productionLines: "Produktionslinien",
  },
  en: {
    inspectionRequiredFacilities: "Inspection-required facilities",
    productionLines: "Production lines",
  },
  es: {
    inspectionRequiredFacilities: "Instalaciones sujetas a inspección",
    productionLines: "Líneas de producción",
  },
};
